// history storage
;(function($) {
	var stateObject = {};

	window.StorageHistory = {
		set: function(name, value, group) {
			var tempValues = '';
			var location = window.location.href;

			if (location.indexOf('?') > 0) {
				var newLocation = location.split('?');
				var arr = newLocation[1].split('&');
				var index = getItemIndex(arr, name);

				if (index === -1) {
					arr.push(name + '=' + value);
				} else {
					var item = arr[index].split('=');

					if (group) {
						arr[index] = name + '=' + item[1] + ',' + value;
					} else {
						arr[index] = name + '=' + value;
					}
				}

				tempValues = arr.join('&');
			} else {
				tempValues = name + '=' + value;
			}

			window.history.pushState(stateObject, name, '?' + tempValues);
		},
		remove: function(name, value) {
			var location = window.location.href;

			if (location.indexOf('?') > 0) {
				var newLocation = location.split('?');
				var arr = newLocation[1].split('&');
				var index = getItemIndex(arr, name);

				if (value === '') {
					var newArr = arr.filter(function(value, index, arr) {
						return value.indexOf(name) === -1;
					});

					window.history.pushState(stateObject, name, '?' + newArr.join('&'));
				} else {
					if (index >= 0) {
						var item = arr[index].split('=');
						var valArray = item[1].split(',');

						var getItem = getItemIndex(valArray, value);

						valArray.splice(getItem, 1);

						if (valArray.length === 0) {
							if (arr.length === 1) {
								window.history.replaceState({}, null, newLocation[0]);
							} else {
								arr.splice(index, 1);
								window.history.pushState(stateObject, name, '?' + arr.join('&'));
							}
						} else {
							arr[index] = item[0] + '=' + valArray.join(',');

							window.history.pushState(stateObject, name, '?' + arr.join('&'));
						}
					}
				}
			}
		},
		reset: function() {
			var url = window.location.origin + window.location.pathname;

			stateObject = {};

			window.history.replaceState(stateObject, null, url);
		}
	};

	function getItemIndex(array, item) {
		var indexInArray = -1;

		$.each(array, function(index, el) {
			var name = el.split('=');

			if (item === name[0]) {
				indexInArray = index;

				return false;
			}
		});

		return indexInArray;
	}
})(jQuery);